import React from 'react';
import { Link } from 'react-router-dom';
import { STEP_LABEL, RUN_STATUS_TONE } from './tdmUtils';

const GLYPH = { SUCCEEDED: '✓', RUNNING: '●', FAILED: '✕', CANCELLED: '✕', SKIPPED: '–', PENDING: '' };

/**
 * Discover (one per source) → Stage → Mask (→ Deploy) with one pill per step; shared by the run lists
 * and cards. A Discover step is an ordinary discovery job on that source database, so its pill names
 * the source and opens the job's results (and stops the click there — the strip also sits inside
 * clickable cards).
 */
const discoverLabel = (s) => (s.detail && s.detail.slug ? `${STEP_LABEL.DISCOVER} ${s.detail.slug}` : STEP_LABEL.DISCOVER);
/** A step's name as the strip shows it ("Discover ohdsi", "Stage", "Mask"). */
export const stepLabel = (s) => (s.stepType === 'DISCOVER' ? discoverLabel(s) : (STEP_LABEL[s.stepType] || s.stepType));
const RunStepStrip = ({ steps, compact }) => {
  if (!steps || steps.length === 0) return null;
  return (
    <div className={`tdm-steps${compact ? ' tdm-steps--compact' : ''}`} data-testid='tdm-step-strip'>
      {steps.map((s, i) => (
        <React.Fragment key={s.id || i}>
          {i > 0 && <span className='tdm-steps__arrow'>→</span>}
          <span className={`tdm-pill tdm-pill--${RUN_STATUS_TONE[s.status] || 'neutral'}`} title={s.error || s.status}>
            <span className='tdm-pill__glyph'>{GLYPH[s.status] || (i + 1)}</span>
            {s.stepType === 'DISCOVER' && s.orchestrationJobId
              ? <Link to={`/results/${s.orchestrationJobId}`} className='tdm-pill__link' data-testid={`tdm-step-discover-link-${s.orchestrationJobId}`}
                title={`Open discovery job #${s.orchestrationJobId}`} onClick={(e) => e.stopPropagation()}>{discoverLabel(s)}</Link>
              : stepLabel(s)}
            {!compact && s.status === 'FAILED' && s.error ? <span className='tdm-pill__note'> · {s.error}</span> : null}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default RunStepStrip;
